import {formsStore} from '../stores/FormsStore';

export function clearSessionForms(session) {
    formsStore.clearForm(session);
}

export function getCurrentFormTitle() {
    return formsStore.currentForm && formsStore.currentForm.title;
}

export function setIsFormActive(session: string, name: string, value: string) {
    const form = formsStore.getFormFromSession(session, name);
    if (form) {
        form.setIsActive(value);
    }
}

export function setIsQueryMode(value: boolean) {
    if (formsStore?.currentForm?.queryMode) {
        formsStore.currentForm.queryMode = value;
    }
}

export function setSavingStatus(status) {
    formsStore.setSavingStatus(status);
}

export function setNetFormData(data) {
    if (!data) {
        formsStore.clearForms();
    } else {
        const form = data.Form && data.Form[0];

        if (form) {
            if (form.NewTable) {
                formsStore.setForms({...data});
            }
        }
    }
}

export async function setCurrentFormName(session, name) {
    formsStore.resetFilters(session, name);
    formsStore.setCurrentForm(session, name);
}

export function setCurrentCell(row: number, col: number) {
    formsStore.currentForm?.setCurrentCell(row, col, null, null);
}

export function getFormState(session, formname) {
    return (
        formsStore.getFormFromSession(session, formname) &&
        formsStore.getFormFromSession(session, formname).formState
    );
}
